(function () {
  if (!window.vvpInit) {
    var gap = function (t) { var s = getComputedStyle(t); return parseFloat(s.columnGap || s.gap) || 0; };
    window.vvpInit = function (root) {
      if (!root || root.getAttribute('data-vvp-ready')) return;
      var track = root.querySelector('[data-vvp-track]');
      if (!track) return;
      root.setAttribute('data-vvp-ready', '1');
      var dotsBox = root.querySelector('[data-vvp-dots]');
      var navBox = root.querySelector('[data-vvp-nav]');
      var prev = root.querySelector('[data-vvp-prev]');
      var next = root.querySelector('[data-vvp-next]');
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.getAttribute('data-auto') === 'true' && !calm;
      var delay = Math.max(2, parseFloat(root.getAttribute('data-delay')) || 5) * 1000;
      var pages = 1, paused = false, visible = true, timer = null, resumeAt = 0;

      function pageW() { return track.clientWidth + gap(track); }
      function maxScroll() { return Math.max(0, track.scrollWidth - track.clientWidth); }
      function count() {
        var w = pageW();
        return Math.max(1, Math.min(12, Math.ceil((track.scrollWidth + gap(track)) / w - 0.02)));
      }
      function current() {
        var x = track.scrollLeft, max = maxScroll();
        if (max > 2 && x >= max - 2) return pages - 1;
        return Math.min(pages - 1, Math.max(0, Math.round(x / pageW())));
      }
      function paint() {
        var i = current();
        var d = dotsBox ? dotsBox.children : [];
        for (var k = 0; k < d.length; k++) d[k].classList.toggle('is-on', k === i);
        if (prev) prev.disabled = i <= 0;
        if (next) next.disabled = i >= pages - 1;
      }
      function build() {
        pages = count();
        if (!dotsBox) return;
        dotsBox.innerHTML = '';
        if (pages < 2) { if (navBox) navBox.style.display = 'none'; return; }
        if (navBox) navBox.style.display = '';
        for (var k = 0; k < pages; k++) {
          var b = document.createElement('button');
          b.type = 'button'; b.className = 'vvp__dot'; b.setAttribute('aria-label', 'Reviews ' + (k + 1) + ' of ' + pages);
          (function (n) { b.addEventListener('click', function () { go(n, true); }); })(k);
          dotsBox.appendChild(b);
        }
        paint();
      }
      function go(n, user) {
        n = Math.max(0, Math.min(pages - 1, n));
        var x = Math.min(n * pageW(), maxScroll());
        track.scrollTo({ left: x, behavior: calm ? 'auto' : 'smooth' });
        if (user) resumeAt = Date.now() + 9000;
      }
      function step() {
        if (paused || !visible || document.hidden || pages < 2 || Date.now() < resumeAt) return;
        var i = current();
        go(i >= pages - 1 ? 0 : i + 1, false);
      }
      function hold(ms) { resumeAt = Date.now() + (ms || 9000); }

      track.addEventListener('scroll', function () { window.requestAnimationFrame(paint); }, { passive: true });
      if (prev) prev.addEventListener('click', function () { go(current() - 1, true); });
      if (next) next.addEventListener('click', function () { go(current() + 1, true); });
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
        root.addEventListener('mouseenter', function () { paused = true; });
        root.addEventListener('mouseleave', function () { paused = false; });
      }
      root.addEventListener('focusin', function () { paused = true; });
      root.addEventListener('focusout', function () { paused = false; });
      track.addEventListener('touchstart', function () { hold(12000); }, { passive: true });
      track.addEventListener('pointerdown', function () { hold(12000); }, { passive: true });
      track.addEventListener('wheel', function () { hold(9000); }, { passive: true });
      window.addEventListener('resize', build);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.2 }).observe(root);
      }
      build();
      if (auto) timer = setInterval(step, delay);
      window.addEventListener('load', build);
    };
    window.vvpScan = function () { [].forEach.call(document.querySelectorAll('[data-vvp]'), window.vvpInit); };
    document.addEventListener('shopify:section:load', window.vvpScan);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', window.vvpScan); else window.vvpScan();
})();